import removeClass from 'remove-class';
import addClass    from 'add-class';
import hasClass    from 'has-class';
import extend      from 'just-extend';
import throttle    from 'raf-throttle';
import {transitionProperty} from './vendor-prefixes';

const defaultOptions = {
	autoplay: true,
	interval: 5000, // Milliseconds between slide changes
	timingFunction: 'ease-in-out', // For height changes in the viewport
};

class SlideShowView {

	constructor(element, options) {
		this.element = element;
		this.options = extend({}, defaultOptions, options);
		this.activeIndex = 0;

		this.init();

		if (this.options.autoplay)
			this.play();
	}

	init() {
		addClass(this.element, 'slideshow');

		this.viewport = document.createElement('ul');
		this.viewport.style.position = 'relative';
		this.viewport.style.width = '100%';
		this.viewport.style.overflow = 'hidden';
		this.viewport.style[transitionProperty] = `height ${this.options.duration}ms ${this.options.timingFunction}`;
		this.viewport.addEventListener('click', () => {
			this.toggle();
		});
		this.viewport.setAttribute('role', 'button');
		addClass(this.viewport, 'slideshow-viewport');

		this.playButton = document.createElement('button');
		this.playButton.setAttribute('title', 'Play');
		this.playButton.innerHTML = '<span class="play-symbol"></span>';
		addClass(this.playButton, 'slideshow-play-btn');
		this.viewport.appendChild(this.playButton);
		this.playButton.addEventListener('click', (event) => {
			this.play();
			event.stopPropagation();
		});

		this.pauseButton = document.createElement('button');
		this.pauseButton.setAttribute('title', 'Pause');
		this.pauseButton.innerHTML = '<span class="pause-symbol"></span>';
		addClass(this.pauseButton, 'slideshow-pause-btn');
		this.viewport.appendChild(this.pauseButton);
		this.pauseButton.addEventListener('click', (event) => {
			this.pause();
			event.stopPropagation();
		});

		this.slides = [];

		for (let i = this.element.children.length - 1; i >= 0; i--) {
			let el = this.element.children[i];
			this.element.removeChild(el);
			var slide = document.createElement('li');
			addClass(slide, 'slideshow-slide');
			slide.appendChild(el);
			this.slides.unshift(slide);
		}

		for (let slide of this.slides)
			this.viewport.appendChild(slide);

		this.element.appendChild(this.viewport);

		if (this.slides.length)
			this.addActiveStyle(this.slides[this.activeIndex]);

		this.updateHeight();

		window.addEventListener('resize', throttle((event) => {
			this.updateHeight();
		}));
	}

	play() {
		this.pause();

		addClass(this.element, 'playing');
		this.viewport.setAttribute('title', 'Pause');

		this.interval = window.setInterval(() => {
			this.next();
		}, this.options.interval);
	}

	pause() {
		if (this.interval)
			window.clearInterval(this.interval);

		removeClass(this.element, 'playing');
		this.viewport.setAttribute('title', 'Play');
	}

	toggle() {
		if (this.playing())
			this.pause();
		else
			this.play();
	}

	playing() {
		return hasClass(this.element, 'playing');
	}

	next() {
		if (this.slides.length) {
			this.removeActiveStyle(this.slides[this.activeIndex]);
			this.activeIndex = (this.activeIndex + 1) % this.slides.length;
			this.addActiveStyle(this.slides[this.activeIndex]);
		}
		else
			this.activeIndex = 0;
	}

	addActiveStyle(slide) {
		addClass(slide, 'active');
	}

	removeActiveStyle(slide) {
		removeClass(slide, 'active');
	}

	updateHeight() {
		if (this.slides.length)
			this.viewport.style.height = this.slides[this.activeIndex].scrollHeight + 'px';
	}

	static create() {
		return new SlideShowView(...arguments);
	}

}

export default SlideShowView;



// WEBPACK FOOTER //
// ./assets/scripts/slide-show.js